<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'personal-myTravel',
  components: { PageTable }
}
</script>
